var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5455 12.5C15.0523 12.5 16.2727 11.2694 16.2727 9.75C16.2727 8.23062 15.0523 7 13.5455 7C12.0386 7 10.8182 8.23062 10.8182 9.75C10.8182 11.2694 12.0386 12.5 13.5455 12.5ZM7.40909 11.125V9.74432C7.40909 9.36776 7.10383 9.0625 6.72727 9.0625C6.35071 9.0625 6.04545 9.36776 6.04545 9.74432V11.125H4.6875C4.3078 11.125 4 11.4328 4 11.8125C4 12.1922 4.3078 12.5 4.6875 12.5H6.04545V13.8807C6.04545 14.2572 6.35071 14.5625 6.72727 14.5625C7.10383 14.5625 7.40909 14.2572 7.40909 13.8807V12.5H8.76705C9.14674 12.5 9.45455 12.1922 9.45455 11.8125C9.45455 11.4328 9.14674 11.125 8.76705 11.125H7.40909ZM13.5455 13.875C11.725 13.875 8.09091 14.7962 8.09091 16.625V18H19V16.625C19 14.7962 15.3659 13.875 13.5455 13.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.8ecfea42.svg";
export { ForwardRef as ReactComponent };